import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import DropDownCalendar from "frontcore/presentation/calendar/views/DropDownCalendar.vue"
import useCoreCalendar from 'frontcore/presentation/calendar/domain/useCoreCalendar'
import {
  CalendarModeOptions,
  DateRange,
  DisabledDateFunction,
  InputDateViewModel,
} from 'frontcore/presentation/calendar/domain/types'
import { Nullable } from 'frontcore/presentation/types'
import { toRefs, watch } from 'vue'


interface Props {
  disableFutureDays?: boolean
  disablePastDays?: boolean
  disabled?: boolean
  disabledDays?: Nullable<DisabledDateFunction | Date[]>
  range?: boolean
  selectionMode?: CalendarModeOptions
  value?: InputDateViewModel['selectedDate']
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CoreCalendar',
  props: {
    disableFutureDays: { type: Boolean, default: false },
    disablePastDays: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    disabledDays: { default: () => [] },
    range: { type: Boolean, default: false },
    selectionMode: { default: CalendarModeOptions.SELECT_DAY },
    value: { default: null }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const props = __props

const {
  disabled,
  disabledDays,
  disableFutureDays,
  disablePastDays,
  range,
  selectionMode,
  value,
} = toRefs(props)

const emit = __emit

const {
  setCalendarSelectedDate,
  updateInternalValue,
  updateMode,
  updateMonth,
  updateYear,
  viewmodel,
} = useCoreCalendar({
  disabledDays: disabledDays,
  disableFutureDays: disableFutureDays,
  disablePastDays: disablePastDays,
  range: range,
  selectionMode: selectionMode,
  value: value,
})

watch(
  () => props.value,
  (newValue, oldValue) => {
    if (newValue === oldValue) { return }
    updateInternalValue(newValue)
    setCalendarSelectedDate()
  }, { immediate: true }
)

const selectValue = (selected: Date) => {
  if (disabled.value || range.value) return
  updateInternalValue(selected)
  emit('input', selected)
}

const updateDateRange = (selected: DateRange) => {
  if (disabled.value || !range.value) { return }
  updateInternalValue(selected)
  if (selected.length === 2) {
    if (selected[0] && selected[1]) {
      emit('input', selected)
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DropDownCalendar, {
    calendarModel: _unref(viewmodel),
    range: _unref(range),
    selectionMode: _unref(selectionMode),
    disablePastDays: _unref(disablePastDays),
    "onInput:value": selectValue,
    onSelectStartRange: updateDateRange,
    onSelectEndRange: updateDateRange,
    onUpdateMode: _unref(updateMode),
    onUpdateMonth: _unref(updateMonth),
    onUpdateYear: _unref(updateYear)
  }, null, 8, ["calendarModel", "range", "selectionMode", "disablePastDays", "onUpdateMode", "onUpdateMonth", "onUpdateYear"]))
}
}

})